import { render, staticRenderFns } from "./ApplicantEvictions.vue?vue&type=template&id=84c9fe0c&scoped=true&"
import script from "./ApplicantEvictions.vue?vue&type=script&lang=js&"
export * from "./ApplicantEvictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c9fe0c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c9fe0c')) {
      api.createRecord('84c9fe0c', component.options)
    } else {
      api.reload('84c9fe0c', component.options)
    }
    module.hot.accept("./ApplicantEvictions.vue?vue&type=template&id=84c9fe0c&scoped=true&", function () {
      api.rerender('84c9fe0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Print/ApplicantEvictions.vue"
export default component.exports